module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/relations/component/relations/relations.component.scss
// module id = ./src/app/relations/component/relations/relations.component.scss
// module chunks = main